import {DATE_FORMATS, US_TIMEZONES} from './date-format.constants';

/**
 * A named display format. Each one has a default and a US pattern in {@link DATE_FORMATS}; the
 * `short*` ones drop the year, for labels that only have to place a moment inside a known period.
 */
export type DateFormatKey =
  | 'date'
  | 'time'
  | 'dateTime'
  | 'dateTimeSeconds'
  | 'shortDate'
  | 'shortDateTime'
  | 'shortDateHour'
  | 'hour'
  | 'dayOfMonth'
  | 'monthYear';

/**
 * How a backend-formatted date string is read back for display: each exact moment format the API
 * sends it in, mapped to the display key it is shown in. See `DateFormatService.reformat`.
 */
export type BackendDateFormats = Readonly<Record<string, DateFormatKey>>;

/** `us` while the selected company sits in a US timezone, `default` otherwise. */
export type DateFormatProfile = 'default' | 'us';

/**
 * Whether an IANA zone id is one of the US states' (or DC's). An exact lookup: a prefix match on
 * `America/` would also catch Canada, Mexico and South America.
 */
export function isUsTimezone(zone: string | null | undefined): boolean {
  return !!zone && US_TIMEZONES.has(zone);
}

/** Tells a {@link DateFormatKey} apart from raw moment tokens. */
export function isDateFormatKey(value: string): value is DateFormatKey {
  return Object.hasOwn(DATE_FORMATS.default, value);
}
